module.exports = __webpack_public_path__ + "img/libyan_labs_logo_white_bg.f77b71cd.png";